import "../config";
import axios from "axios";

class Api {
    constructor() {
        this.base_url = global.BASE_URL;
    }

    msg(status, message, data) {
        return {
            status,
            message,
            data,
        };
    }

    async get(path) {
        try {
            const response = await axios.get(this.base_url + path);
            if (response && response?.data) {
                return this.msg(
                    true,
                    "berhasil mendapatkan data",
                    response.data
                );
            } else {
                return this.msg(false, "gagal mendapatkan data", null);
            }
        } catch (error) {
            console.error("error when requesting: ", error);
            return this.msg(false, "Internal Server Error", null);
        }
    }

    async post(path, data, header) {
        try {
            const response = await axios.post(
                this.base_url + path,
                data,
                header
            );
            if (response && response.data) {
                if (response.data.status === 200 || response.data.status) {
                    return {
                        success: true,
                        message: response.data.message,
                        data: response.data.data,
                    };
                } else {
                    return {
                        success: false,
                        message: response.data.message,
                        data: response.data.data,
                    };
                }
            }

            return {
                success: false,
                message: "gagal mendapatkan respon",
                data: null,
            };
        } catch (error) {
            console.error("error ketika melakukan post data", error);
            return {
                success: false,
                message: "internal server error",
                data: null,
            };
        }
    }
    async patch(path, data, header) {
        try {
            const response = await axios.patch(
                this.base_url + path,
                data,
                header
            );
            if (response && response.data) {
                if (response.data.status === 200 || response.data.status) {
                    return {
                        success: true,
                        message: response.data.message,
                        data: response.data.data,
                    };
                } else {
                    return {
                        success: false,
                        message: response.data.message,
                        data: response.data.data,
                    };
                }
            }

            return {
                success: false,
                message: "gagal mendapatkan respon",
                data: null,
            };
        } catch (error) {
            console.error("error ketika melakukan post data", error);
            return {
                success: false,
                message: "internal server error",
                data: null,
            };
        }
    }
}

export default Api;
